import { IconEnum } from './enum/IconEnum';

export enum IconsEnum {
    ADVICE = 'advice',
    ARRIVAL = 'arrival',
    ARTICLE = 'article',
    ARROW = 'arrow',
    ATHLETES_SERVICES = 'athletesServices',
    ATTACHEMENT = 'attachement',
    BAGS_LIGHTENING = 'bagsLightening',
    BAN = 'ban',
    BEACH = 'beach',
    BIB = 'bib',
    BIB_COLLECTION = 'bibCollection',
    BOOKMARK_CHECKED = 'bookmarkChecked',
    BRIEFING = 'briefing',
    BURGER = 'burger',
    BUS = 'bus',
    CALENDAR = 'calendar',
    CAMERA = 'camera',
    CAR = 'car',
    CHAIN = 'chain',
    CHARITY_BIB = 'charityBib',
    CHECKBOX = 'checkbox',
    CHECKPOINT = 'checkpoint',
    CHEVRON = 'chevron',
    CHEVRON_DOWN = 'chevronDown',
    CHEVRON_LEFT = 'chevronLeft',
    CHEVRON_RIGHT = 'chevronRight',
    CHEVRON_UNCONSTRAINED = 'chevronUnconstrained',
    CHEVRON_UP = 'chevronUp',
    CLOSE = 'close',
    CLIPBOARD = 'clipboard',
    COASTAL_PATH = 'coastalPath',
    DAY_TIME = 'dayTime',
    DESERT = 'desert',
    DISCOVER = 'discover',
    DONATION = 'donation',
    DOWN = 'down',
    DOWNLOAD = 'download',
    EVENT_CENTER = 'eventCenter',
    EVENT_VILLAGE = 'eventVillage',
    EVENTS = 'events',
    EXCITED = 'excited',
    EXCEL = 'excel',
    FINISH_INDEX = 'finishIndex',
    FINISHERS = 'finishers',
    FINISH_WS = 'finishWs',
    FLAG = 'flag',
    FROZEN_INDEX = 'frozenIndex',
    LINEPLUS = 'linePlus',
    FOURPLUS = 'fourPlus',
    NINEPLUS = 'ninePlus',
    GAME = 'game',
    GLACIER = 'glacier',
    GLOBE = 'globe',
    HAND_COINS = 'handCoins',
    HEART = 'heart',
    HELP = 'help',
    HIGH_ALTITUDE = 'highAltitude',
    HIKING_TRAIL = 'hikingTrail',
    HILL = 'hill',
    HOME = 'home',
    HOURGLASS = 'hourglass',
    INFO = 'info',
    INFO_POINT = 'infoPoint',
    INTERVIEW = 'interview',
    INVOLVED = 'involved',
    JUNGLE = 'jungle',
    LEFT = 'left',
    LEGEND = 'legend',
    LIVE = 'live',
    LOCK = 'lock',
    LOGO_AD_BG = 'logoAdBg',
    LOGO_SIMPLIFIED = 'logoSimplified',
    LOGO_SIMPLIFIED_DARK = 'logoSimplifiedDark',
    LOGO_FINALS = 'logoFinals',
    LOGO_MAJOR = 'logoMajor',
    LOGOUT = 'logout',
    MAG = 'mag',
    MANDATORY_EQUIPMENT_CHECK = 'mandatoryEquipmentCheck',
    MEDIA = 'media',
    MEDIA_CENTER = 'mediaCenter',
    MOBILITY = 'Mobility',
    MOUNTAIN = 'mountain',
    MY_ACHIEVEMENT = 'myAchievement',
    MY_DASHBOARD = 'myDashboard',
    MY_INFORMATION = 'myInformation',
    MY_REGISTRATION = 'myRegistration',
    MY_REWARDS = 'myRewards',
    MY_UTMB_POINTS = 'myUtmbPoints',
    MY_UTMB_POINTS_GENERIC = 'myUtmbPointsGeneric',
    NEXT = 'next',
    NIGHT_TIME = 'nightTime',
    NO = 'no',
    OTHER = 'other',
    PARKING = 'parking',
    PEN = 'pen',
    PHOTOS = 'photos',
    PIN = 'pin',
    PLANE = 'plane',
    PLUS_LOYALTY = 'plusLoyalty',
    QUOTE = 'quote',
    RACE = 'race',
    RACE_FLAG = 'raceFlag',
    RANDOM = 'random',
    REFUELING_STAND = 'refuelingStand',
    RIGHT = 'right',
    ROAD = 'road',
    RS = 'rs',
    RULER = 'ruler',
    RUNNER = 'runner',
    RUNNER_BAG = 'runnerBag',
    RUNNING_STONE = 'runningStone',
    RUNNING_STONES = 'runningStones',
    SEARCH = 'search',
    SHARE = 'share',
    SHOP = 'shop',
    SINGLE_TRACK = 'singleTrack',
    SMILEY_LAUGH = 'smileyLaugh',
    SMILEY_SHY = 'smileyShy',
    SMILEY_SURPRISED = 'smileySurprised',
    SOCIAL_DAILYMOTION = 'dailymotion',
    SOCIAL_FACEBOOK = 'facebook',
    SOCIAL_INSTAGRAM = 'instagram',
    SOCIAL_LINKEDIN = 'linkedin',
    SOCIAL_STRAVA = 'strava',
    SOCIAL_TIKTOK = 'tiktok',
    SOCIAL_TWITTER = 'twitter',
    SOCIAL_WECHAT = 'wechat',
    SOCIAL_X = 'socialX',
    SOCIAL_YOUTUBE = 'youtube',
    SPECTATORS = 'spectators',
    SPINNER = 'spinner',
    STAR = 'star',
    STAR_BORDER = 'starBorder',
    START = 'start',
    START_INDEX = 'startIndex',
    START_WS = 'startWs',
    STONE_EVENTS = 'stone_events',
    STONE_MAJORS = 'stone_majors',
    SUPPORTERS = 'supporters',
    TERRAIN = 'terrain',
    THUMB_UP = 'thumbUp',
    TICKET = 'ticket',
    TOP1 = 'top1',
    TOP2 = 'top2',
    TOP3 = 'top3',
    TOURISM = 'tourism',
    TRAIL_RUNNERS = 'trailRunners',
    TRAIN = 'train',
    TRASH = 'trash',
    TRASH_SECOND = 'trashSecond',
    TUNNEL = 'tunnel',
    UP = 'up',
    USER = 'user',
    UTMB_FINAL = 'utmbFinal',
    UTMB_GROUP = 'utmbGroup',
    UTMB_RUNNER = 'utmbRunner',
    VOLONTEER = 'VOLONTEER',
    VOLUNTEERS = 'volunteers',
    WOODS = 'woods',
    WS_CATEGORIES = 'WS_CATEGORIES',
}

export interface IconsProps {
    variant: IconsEnum | IconEnum;
    color?: string;
    clss?: string;
    width?: number;
    height?: number;
    hideText?: boolean;
}

export interface IconSvgProps {
    color?: string;
    clss?: string;
    width?: number;
    height?: number;
    hideText?: boolean;
}
